import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// This is a styling element to be wrapped around each of the mobile filter
// controls, which adds a faint gray line between each filter
const MobileProductListingFilterWrapper = t0 => {
  const $ = _c(11);
  const {
    children,
    id,
    label
  } = t0;
  const isQuickshipFilter = id === "quickship";
  const t1 = !isQuickshipFilter;
  let t2;
  if ($[0] !== isQuickshipFilter || $[1] !== t1) {
    t2 = classNames("[&:last-child]:border-0 [&:last-child]:mb-0 [&:last-child]:pb-0", {
      "border-b-[1px] border-gray-light7 mb-5 pb-5": t1,
      "border-0 mb-3 pb-0": isQuickshipFilter
    });
    $[0] = isQuickshipFilter;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `mobile-filter-section-${id ?? ""}`;
  let t4;
  if ($[3] !== isQuickshipFilter || $[4] !== label) {
    t4 = !!label && !isQuickshipFilter && <h3 className="mb-2 text-base font-bold text-gray">{label}</h3>;
    $[3] = isQuickshipFilter;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <div className={t2} data-xc={t3}>{t4}{children}</div>;
    $[6] = children;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
MobileProductListingFilterWrapper.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  label: PropTypes.string
};
export default MobileProductListingFilterWrapper;